import React from "react";
import {Link} from "react-router-dom";
import {MINIO_URL} from "../config";

function GameCard({game}) {
    return (
        <Link to={`/game/${game.id}`}
              className="group block bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border-2 border-white/40 hover:border-white/60 backdrop-blur-sm w-fit mx-auto">
            <div
                className="min-h-80 sm:min-h-96 bg-[#ffcccc] overflow-hidden relative flex items-center justify-center">
                <img src={`${MINIO_URL}${game.id}/${game.thumb}`} alt={game.name}
                     className="h-full w-auto max-h-80 sm:max-h-96 object-contain group-hover:scale-110 transition-transform duration-500"/>
                <div
                    className="absolute inset-0 bg-gradient-to-t from-[#C8102E]/90 via-[#E31E3C]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="p-3 bg-gradient-to-br from-[#C8102E]/90 via-[#E31E3C]/90 to-[#C8102E]/90 backdrop-blur-sm">
                <div
                    className="font-semibold text-white group-hover:text-white/90 transition-colors drop-shadow-lg">{game.name}</div>
                <div className="text-xs text-white/90 mt-1">{game.category}</div>
            </div>
        </Link>
    );
}

export default GameCard;